const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/ResponsibilitiesCard/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        cardTitle: 'Zuständig für mich',
    },
    __RELATIVE_SOURCE_FILE__
);
